import React from "react";
import ProductCard from "../components/ProductCard";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchProduct } from "../actions/actionCreator";
import Loader from "../components/Loader";

function ProductPage() {
    const { fetchAllProductsLoading, products } = useSelector((state) => state.product);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchProduct());
    }, []);

    if (fetchAllProductsLoading) {
        return <Loader/>;
    }

    return (
        <div>
            <div className=" mt-20 flex flex-row items-center justify-between px-5">
                <div className="text-lg">Men's Shoes (477)</div>
                <div className="flex flex-row gap-10 items-center justify-center">
                    <div className="flex flex-row gap-2 items-center justify-center">
                        Hide Filters
                        <span className="material-symbols-outlined cursor-pointer">tune</span>
                    </div>
                    <div className="flex flex-row gap-1 items-center justify-center">
                        Sort By
                        <span className="material-symbols-outlined cursor-pointer">arrow_drop_down</span>
                    </div>
                </div>
            </div>
            <div className="flex flex-row mt-5">
                <div className=" mx-5 h-[100vh] w-[15%]">
                    <div className=" border-b-2 border-solid border-gray-200 text-left pb-10 pt-2 text-lg flex flex-col gap-2">
                        <div>Lifestyle</div>
                        <div>Jordan</div>
                        <div>Running</div>
                        <div>Basketball</div>
                        <div>Football</div>
                        <div>Training & Gym</div>
                        <div>Skateboarding</div>
                        <div>Golf</div>
                        <div>Tennis</div>
                        <div>Althetics</div>
                        <div>Walking</div>
                    </div>
                </div>
                <div className=" h-auto w-[85%] grid grid-cols-3 gap-10 px-5 py-2">
                    {products?.map((el) => {
                        return <ProductCard key={el.id} el={el} />;
                    })}
                </div>
            </div>
        </div>
    );
}

export default ProductPage;
